/**
 * signalR properties
 */
export const SIGNAL_R_PROPERTIES = {
  busReplacementsHub: 'staff-app-replacements-hub',
  method: 'replacements',
};
